<template>
  <div class="text-center py-40 space-y-12">
    <template v-if="filtered">
      <h2 class="text-h3">No favorites for this care type.</h2>
      <p class="text-body">Select All or another care type to see your favorites.</p>
    </template>
    <template v-else>
      <h2 class="text-h3">You don’t have any favorites – yet.</h2>
      <p class="text-body">Did you know you can create a favorites list of your top sitters, nannies, and caregivers?</p>
      <p class="text-body">Look for the heart next to a caregiver’s name in search or on their profile.</p>
    </template>
  </div>
</template>

<script setup lang="ts">
defineProps<{ filtered: boolean }>();
</script>
